module.exports = __webpack_public_path__ + "img/website-testing.6ef520c7.svg";